/* eslint-disable @scandipwa/scandipwa-guidelines/derived-class-names */
import { withRouter } from 'react-router-dom';

import {
    MyAccountOverlay as SourceMyAccountOverlay
} from 'SourceComponent/MyAccountOverlay/MyAccountOverlay.component';

import './MyAccountOverlay.override.style';

/** @namespace PeggysagePwa/Component/MyAccountOverlay/Component */
export class MyAccountOverlay extends SourceMyAccountOverlay {
    // ...
}

export default withRouter(MyAccountOverlay);
